import { Component } from '@angular/core';

/**
 * Task 2616 Phase 7 — System unavailable page (Task 2760 boundary).
 * Shown when the API is unreachable (status 0, 502, 503 bare, 504).
 * Final visual design is owned by Task 2760. This is a placeholder route.
 * Must not use the normal application layout, sidebar resolver, permission guard or NavBar.
 */
@Component({
  standalone: false,
  selector: 'app-system-unavailable',
  template: `
    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;">
      <h1 style="font-size:2rem;margin-bottom:1rem;">System unavailable</h1>
      <p style="color:#666;margin-bottom:2rem;">The system cannot be reached right now. Please check your connection or try again later.</p>
      <a href="/" style="padding:0.75rem 1.5rem;background:#0078d4;color:#fff;border-radius:4px;text-decoration:none;">
        Return to home
      </a>
    </div>
  `,
})
export class SystemUnavailableComponent {}
